import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import Form from './Form';
import ResendForm from './ResendForm';

const ResetPasswordRequestComponent = ({
  status,
  errors,
  submitCount,
  values: { email },
  redirectToLogin,
}) => {
  const isSubmittedSuccessfully = isEmpty(status) && isEmpty(errors) && submitCount > 0;

  return (
    isSubmittedSuccessfully ? (
      <ResendForm
        email={email}
        redirectToLogin={redirectToLogin}
      />
    ) : (
      <Form
        status={status}
        redirectToLogin={redirectToLogin}
      />
    )
  );
};

ResetPasswordRequestComponent.defaultProps = {
  status: undefined,
  errors: {},
};

ResetPasswordRequestComponent.propTypes = {
  status: PropTypes.shape(),
  submitCount: PropTypes.number.isRequired,
  errors: PropTypes.shape(),
  values: PropTypes.shape({
    email: PropTypes.string.isRequired,
  }).isRequired,
  redirectToLogin: PropTypes.string.isRequired,
};

export default ResetPasswordRequestComponent;
